import { render, staticRenderFns } from "./logGroupModel.vue?vue&type=template&id=1df61d1e"
import script from "./logGroupModel.vue?vue&type=script&lang=js"
export * from "./logGroupModel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports